export default {
  SelectDate: 'Chọn kỳ báo cáo',
  ReportParam: 'Tham số báo cáo',
  FromDate: 'Từ ngày',
  ToDate: 'Đến ngày',
  Source: 'Nguồn',
  Chapter: 'Chương',
  SubKind: 'Khoản',
  All: 'Tất cả',
  Summary: 'Tổng hợp',
  Option: 'Tùy chọn',
    Mode: 'Mẫu báo cáo',
    CreditAccount: 'TK Có',
    DebitAccount: 'TK Nợ',
    ItemCode: 'Mục',
  SubItemCode: 'Tiểu Mục'

}